import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Mail } from "lucide-react";
import { api } from "../lib/api";

/** Link ai follow-up con badge degli impegni aperti (sidebar desktop / header mobile). */
export const FollowUpBadge = ({ compact }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    const load = () => api.get("/followups/count").then((r) => setN(r.data.aperti)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);
  if (compact) {
    return (
      <NavLink to="/followup" data-testid="followup-badge-mobile" className="relative rounded-md p-2 text-muted-foreground hover:bg-secondary hover:text-white" title="Follow-up">
        <Mail className="h-5 w-5" />
        {n > 0 && <span data-testid="followup-count-mobile" className="absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-white">{n}</span>}
      </NavLink>
    );
  }
  return n > 0 ? <span data-testid="followup-count" className="ml-auto rounded-full bg-primary px-2 py-0.5 text-[10px] font-bold text-white">{n}</span> : null;
};
